import { getGridStringOperators, GridColDef, GridSortItem } from '@mui/x-data-grid-pro';
import { useIntl } from 'react-intl';

// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  useConceptGroups,
  useGetConceptGroupConceptsDetailsQuery,
} from '@verantos-dev/data-access-concept-groups';
import { ConceptGroup, ConceptGroupConcept } from '@verantos-dev/types-concepts';

import { useExportConceptGroup } from './useExportConceptGroup';

export const useConceptGroupDetailsDialog = (conceptGroupId: string) => {
  const intl = useIntl();
  const { conceptGroups, isConceptGroupsLoading, conceptGroupsError } = useConceptGroups();

  const conceptGroupDetails = conceptGroups.find(
    (conceptGroup) => conceptGroup.conceptGroupId === conceptGroupId
  ) as ConceptGroup | undefined;

  const { exporting, handleExportAll } = useExportConceptGroup({
    conceptGroupId,
    conceptGroupName: conceptGroupDetails?.conceptGroupName || '',
  });

  const useGetConceptsData = (searchParams?: string) => {
    return useGetConceptGroupConceptsDetailsQuery({
      conceptGroupId,
      searchParams: searchParams ?? '',
    });
  };

  const stringOperators = getGridStringOperators().filter((op) =>
    ['contains', 'doesNotContain', 'equals', 'doesNotEqual', 'startsWith', 'endsWith'].includes(
      op.value
    )
  );

  const columns: GridColDef<ConceptGroupConcept>[] = [
    {
      field: 'conceptId',
      headerName: intl.formatMessage({ id: 'conceptGroup.details.omopConceptId' }),
      flex: 1,
      filterOperators: stringOperators,
    },
    {
      field: 'conceptName',
      headerName: intl.formatMessage({ id: 'conceptGroup.details.conceptName' }),
      flex: 2,
      filterOperators: stringOperators,
    },
    {
      field: 'vocabularyId',
      headerName: intl.formatMessage({ id: 'conceptGroup.details.vocabulary' }),
      flex: 1,
      filterOperators: stringOperators,
    },
    {
      field: 'conceptCode',
      headerName: intl.formatMessage({ id: 'conceptGroup.details.conceptCode' }),
      flex: 1,
      filterOperators: stringOperators,
    },
    {
      field: 'domainId',
      headerName: intl.formatMessage({ id: 'conceptGroup.details.domain' }),
      flex: 1,
      filterOperators: stringOperators,
    },
  ];

  const sortModel: GridSortItem[] = [{ field: 'conceptName', sort: 'asc' }];

  return {
    conceptGroupDetails,
    isConceptGroupDetailsLoading: isConceptGroupsLoading,
    conceptGroupDetailsError: conceptGroupsError,
    useGetConceptsData,
    columns,
    sortModel,
    exporting,
    handleExportAll,
  };
};
